import { Injectable, Injector } from '@angular/core';
import { EntityCollectionServiceElementsFactory } from '@ngrx/data';
import {AbstractRepositoryV2} from "../../../../../../core/service/v2/abstractRepositoryV2";
import {InsolesProviderModelModel} from "../../../api/entity/insolesProviderModel.model";

@Injectable({
    providedIn: 'root'
})
export class InsolesProviderModelRepository extends AbstractRepositoryV2<InsolesProviderModelModel> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('InsolesProviderModel', serviceElementsFactory, injector);
    }
}
